// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"0e98b3c9","977":"9ceffc10"}[chunkId] + ".chunk.js";
};